'use client';
import { useState } from 'react';

const ContactForm = () => {
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);

    if (
      !data.get('fName').trim() ||
      !data.get('lName').trim() ||
      !data.get('email').trim() ||
      !data.get('company-name').trim()
    ) {
      setSubmitMessage('Complete required fields');
      setTimeout(() => {
        setSubmitMessage(false);
      }, 5000);
      return;
    }

    try {
      const resp = await fetch('/contact-form.html', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(data).toString(),
      });

      if (resp.ok) {
        setSubmitMessage('Submitted!');
        form.reset();
      } else {
        setSubmitMessage('Failed');
      }
    } catch (err) {
      console.error('Network error', err);
      setMessage('Failed');
    }

    setTimeout(() => {
      setSubmitMessage(false);
    }, 5000);
  };

  return (
    <form
      name="contact"
      method="POST"
      data-netlify="true"
      onSubmit={handleSubmit}
      className="grid grid-cols-1 gap-4 text-[#575757] md:grid-cols-2 md:gap-8"
    >
      {/* Netlify hidden input */}
      <input type="hidden" name="form-name" value="contact" />

      <div className="col-span-2 flex flex-col md:col-span-1">
        <label htmlFor="fName">
          First Name <span className="ml-1 text-brittainRed">*</span>
        </label>
        <input
          id="fName"
          type="text"
          name="fName"
          className="border-b border-b-[#575757] bg-transparent text-black focus:border-brittainBlue focus:outline-none"
          autoComplete="given-name"
          required
        />
      </div>

      <div className="col-span-2 flex flex-col md:col-span-1">
        <label htmlFor="lName">
          Last Name <span className="ml-1 text-brittainRed">*</span>
        </label>
        <input
          id="lName"
          type="text"
          name="lName"
          className="border-b border-b-[#575757] bg-transparent text-black focus:border-brittainBlue focus:outline-none"
          autoComplete="family-name"
          required
        />
      </div>

      <div className="col-span-2 flex flex-col md:col-span-1">
        <label htmlFor="email">
          Email <span className="ml-1 text-brittainRed">*</span>
        </label>
        <input
          id="email"
          type="email"
          name="email"
          className="border-b border-b-[#575757] bg-transparent text-black focus:border-brittainBlue focus:outline-none"
          autoComplete="email"
          required
        />
      </div>

      <div className="col-span-2 flex flex-col md:col-span-1">
        <label htmlFor="phone">Phone Number</label>
        <input
          id="phone"
          type="tel"
          name="phone"
          className="border-b border-b-[#575757] bg-transparent text-black focus:border-brittainBlue focus:outline-none"
          autoComplete="tel"
        />
      </div>

      <div className="col-span-2 flex flex-col">
        <label htmlFor="company-name">
          Company Name <span className="ml-1 text-brittainRed">*</span>
        </label>
        <textarea
          id="company-name"
          name="company-name"
          className="border-b border-b-[#575757] bg-transparent text-black focus:border-brittainBlue focus:outline-none"
          rows="1"
          required
        />
      </div>

      <div className="col-span-2 flex flex-col">
        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          className="border-b border-b-[#575757] bg-transparent text-black focus:border-brittainBlue focus:outline-none"
          rows="1"
        />
      </div>

      <button
        type="submit"
        disabled={submitMessage.length > 0}
        className={`col-span-2 mt-6 flex min-h-[44px] w-50 items-center justify-center justify-self-center rounded-3xl border border-3 border-brittainRed py-2 font-lato text-2xl font-bold tracking-widest text-brittainRed hover:border-brittainRed hover:bg-brittainRed hover:text-white focus:ring-2 focus:ring-brittainRed focus:ring-offset-2 focus:outline-none md:mt-0 lg:justify-self-end ${
          submitMessage ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
        }`}
        aria-label={submitMessage ? submitMessage : 'Submit contact form'}
      >
        {submitMessage ? submitMessage : 'SUBMIT'}
      </button>
    </form>
  );
};

export default ContactForm;
